<div class="home-info-card">
  <img src="../../../assets/svg/icons/star.svg" alt="" />
  <div class="content">
    <span><b>Bem-vindo(a) ao Saúde Conectada!</b></span>
    <p>
      Sua jornada para uma gestão de saúde mais integrada e inteligente começa
      agora. Explore os recursos, personalize sua experiência e descubra como o
      Saúde Conectada pode apoiar suas decisões no dia a dia.
    </p>
  </div>
</div>
